module.exports = __webpack_public_path__ + "static/media/list-outline.ba9677ae.svg";